import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=29f189fb&scoped=true&"
import script from "./Warning.vue?vue&type=script&lang=js&"
export * from "./Warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f189fb",
  null
  
)

export default component.exports